import { gql } from "@apollo/client";

export const REGISTRATIONS_LIST = gql`
  query RegistrationsList($vehicleId: ID, $sort: [RegistrationSort!], $first: Int, $skip: Int) {
    registrationsList(
      filter: { registrations: { id: { equals: $vehicleId } } },
      sort: $sort,
      first: $first,
      skip: $skip
    ) {
      items {
        id
        registrationNumber
        annualDate
        expiryDate
        createdAt
        deletedAt
        document {
          items {
            filename
            downloadUrl
            id
          }
        }
        registrations {
          id
          make
          model
        }
        updatedAt
      }
      count
    }
  }
`;

export const REGISTRATION_CREATE = gql`
  mutation RegistrationCreate($data: RegistrationCreateInput!) {
    registrationCreate(data: $data) {
      id
    }
  }
`;

export const REGISTRATION_UPDATE = gql`
  mutation RegistrationUpdate($filter: RegistrationKeyFilter, $data: RegistrationUpdateInput!) {
    registrationUpdate(filter: $filter, data: $data) {
      id
    }
  }
`;

export const REGISTRATION_DELETE = gql`
  mutation RegistrationDelete($filter: RegistrationKeyFilter) {
    registrationDestroy(filter: $filter) {
      success
    }
  }
`;

export const REGISTRATION_GET_LIST_FILTER = gql`
  query RegistrationGet($id: ID!) {
    registrationsList(filter: { id: { equals: $id } }) {
      items {
        id
        registrationNumber
        annualDate
        expiryDate
        createdAt
        deletedAt
        document {
          items {
            filename
            downloadUrl
            id
          }
        }
        registrations {
          id
          make
          model
        }
      }
    }
  }
`;
